<template>
  <g v-if="matDecoration" :mask="matMaskId ? `url(#${matMaskId})` : undefined">
    <StarOutline v-if="matDecoration === 'star-outline'" :artworkOpenings="artworkOpenings" :decorationColor="matDecorationColor" />
    <OrnamentStars v-else-if="matDecoration === 'ornament-stars'" :artworkOpenings="artworkOpenings" />
    <FlowerOrnament v-else-if="matDecoration === 'flower-ornament'" :artworkOpenings="artworkOpenings" />
    <SmallStarStaggered v-else-if="matDecoration === 'small-star-staggered'" :artworkOpenings="artworkOpenings" :matWidth="matWidth" :matHeight="matHeight" :decorationColor="matDecorationColor" />
  </g>
</template>

<script>
import FlowerOrnament from './mat-decorations/FlowerOrnament.vue';
import OrnamentStars from './mat-decorations/OrnamentStars.vue';
import SmallStarStaggered from './mat-decorations/SmallStarStaggered.vue';
import StarOutline from './mat-decorations/StarOutline.vue';

export default {
  props: {
    frameSpec: {
      type: Object,
      required: true
    },
    artworkOpenings: {
      type: Array,
      required: true
    },
    matWidth: {
      type: Number,
      required: true
    },
    matHeight: {
      type: Number,
      required: true
    },
    matMaskId: {
      type: String,
      default: null
    }
  },
  components: {
    SmallStarStaggered,
    FlowerOrnament,
    OrnamentStars,
    StarOutline
  },
  computed: {
    matOrMountName() {
      if (!this.frameSpec) {
        return null;
      } else if (this.frameSpec.isFloated()) {
        return this.frameSpec.mount.name;
      } else if (this.frameSpec.mats[0]) {
        return this.frameSpec.mats[0].name
      } else {
        return null;
      }
    },
    matDecoration() {
      if (this.matOrMountName === "STAR-WHITE" || this.matOrMountName === "STAR-SAGE") {
        return "small-star-staggered";
      } else if (this.matOrMountName === "ORN-WHITE" && !this.frameSpec.isFloated()) {
        return "ornament-stars";
      } else if (this.matOrMountName === "FLOWER-WHITE" && !this.frameSpec.isFloated()) {
        return "flower-ornament";
      } else if (this.matOrMountName === "STAR-OUT-WHITE" || this.matOrMountName === "STAR-OUT-BLACK") {
        return "star-outline";
      } else {
        return null;
      }
    },
    matDecorationColor() {
      if (this.matOrMountName === "STAR-OUT-BLACK") {
        return "white"
      } else {
        return "black"
      }
    }
  },
};
</script>

<style lang="scss">

</style>
